import { formatNumberWithCommas } from "Utilities/Number/formatNumberWithCommas";

const defaultOptions = {
  roundToWholeDollar: false,
  isCents: false,
  includeCommas: true,
  removeTrailingZeros: true,
  limitToTwoDecimals: true,
  includeDollarSign: false,
};

const stripFormattingAndConvertToNumber = (amount) => {
  // strip out "$" and ","
  const cleanVal = String(amount).replace("$", "").replaceAll(",", "");
  return Number(cleanVal);
};

export function formatAmountForDisplay(amount, userOptions = {}) {
  const options = {
    ...defaultOptions,
    ...userOptions,
  };

  let value = stripFormattingAndConvertToNumber(amount);

  if (options.isCents) {
    value = value / 100;
  }

  if (options.limitToTwoDecimals) {
    value = Number(value).toFixed(2);
  }

  if (options.roundToWholeDollar) {
    value = Math.round(value);
  }

  if (options.removeTrailingZeros) {
    value = String(value).replace(".00", "").replace(".0", "");
  }

  if (options.includeCommas) {
    value = formatNumberWithCommas(value);
  }

  if (options.includeDollarSign) {
    return `$${String(value)}`;
  }

  return String(value);
}
